import React from 'react';
import cn from 'classnames';
import PromoBadgeWithTooltip from '../../PromoBadgeWithTooltip';
import s from './AvatarIndicators.scss';
const IndicatorWrapper = ({ user, topLeft, topRight, bottomLeft, bottomRight, className, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, topLeft && /*#__PURE__*/ React.createElement("div", {
        className: s['top-left']
    }, topLeft), topRight && /*#__PURE__*/ React.createElement("div", {
        className: s['top-right']
    }, topRight === 'tierSubscribed' ? /*#__PURE__*/ React.createElement(React.Fragment, null, (user === null || user === void 0 ? void 0 : user.isSubscribed) && /*#__PURE__*/ React.createElement(PromoBadgeWithTooltip, {
        badgeType: "tier",
        size: 16
    })) : topRight), bottomLeft && /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-left']
    }, bottomLeft), bottomRight && /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-right']
    }, bottomRight), children);
};
IndicatorWrapper.displayName = 'IndicatorWrapper';
export default IndicatorWrapper;
